import React,{useEffect} from 'react'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import {Link} from 'react-router-dom'

const Error404 = (props) => {
    useEffect(() => {
        window.document.title = "Page Not Found - Premier Medical Clinic"
    }, [])
    return (
        <>
        <Header />
            <div className='bg-page' id="website-responsive">
                {/* <BannerCategory /> */}
                <section>
                    <div className='container-zk my-md-5 text-center bg-light py-5'>
                        <h4 className='fw-bolder fs-2hx text-gray-900 mb-4'>This page doesn't seem to exist.</h4>
                        <div className='fw-semibold fs-6 text-gray-500 mb-7'>It looks like the link pointing here was faulty. Maybe try searching?</div>
                        <div className='mt-5'>
                            <Link to='/' className='btn btn-sm btn-zk-primary'>
                                Return Home
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        <Footer />
        </>
    )
}

export default Error404
